import { useReducer, useCallback } from "react";
import { useHistory } from "react-router-dom";

function httpReducer(state, action) {
  if (action.type === "SEND") {
    return {
      data: null,
      error: null,
      status: "pending",
    };
  }

  if (action.type === "SUCCESS") {
    return {
      data: action.responseData,
      error: null,
      status: "completed",
    };
  }

  if (action.type === "ERROR") {
    return {
      data: null,
      error: action.errorMessage,
      status: "completed",
    };
  }

  return state;
}

function useHttp(requestFunction, startWithPending = false) {
  const history=useHistory();
  const [httpState, dispatch] = useReducer(httpReducer, {
    status: startWithPending ? "pending" : null,
    data: null,
    error: null,
  });

  const sendRequest = useCallback(
    async function (requestData, API_PARAMS, REQUEST_TYPE) {
      dispatch({ type: "SEND" });
      try {
        const responseData = await requestFunction(
          requestData,
          API_PARAMS,
          REQUEST_TYPE
        );
        dispatch({ type: "SUCCESS", responseData });
      } catch (error) {
        console.log(error);
        history.replace('/page-not-found');
        dispatch({
          type: "ERROR",
          errorMessage: error.response.data || "Something went wrong!",
        });
      }
    },
    [requestFunction]
  );

  return {
    sendRequest,
    ...httpState,
  };
}

export default useHttp;
